export default __webpack_public_path__ + "static/media/inspiration1.5653580a.png";